document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".close__icon").addEventListener("click", () => {
    document.querySelector(".header__icon--summary").click();
  });
  // sticky atc script
  const stickyAtc = document.querySelector(".desktop-sticky-atc");
  window.addEventListener("scroll", (e) => {
    if (window.scrollY > 900 && screen.width >= 0) {
      stickyAtc?.classList.add("show");
    } else {
      stickyAtc?.classList.remove("show");
    }
  });
});
